import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";

import "./AboutContentStyle.css";

import AboutSlideOne from "./AboutSlideOne";
import AboutSlideTwo from "./AboutSlideTwo";
import AboutSlideThree from "./AboutSlideThree";

const AboutContent = ({ allRooms }) => {
  return (
    <>
      <Swiper
        autoHeight={false}
        spaceBetween={24}
        pagination={{
          clickable: true,
          dynamicBullets: true,
          horizontalClass: "aboutSwiper-pagination",
        }}
        modules={[Pagination]}
        className="aboutSwiper"
      >
        <SwiperSlide>
          <AboutSlideOne />
        </SwiperSlide>

        <SwiperSlide>
          <AboutSlideTwo />
        </SwiperSlide>

        <SwiperSlide>
          <AboutSlideThree allRooms={allRooms} />
        </SwiperSlide>
      </Swiper>
    </>
  );
};

export default AboutContent;
